import { render } from "./ButtonText.vue?vue&type=template&id=4ff7c980&ts=true"
import script from "./ButtonText.ts?vue&type=script&lang=ts&external"
export * from "./ButtonText.ts?vue&type=script&lang=ts&external"

import "./ButtonText.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__